import React, { useState, useEffect, useRef } from "react";
import { Edit, IdCard, ListCheck, CalendarDays, Gift } from "lucide-react";

import useDocumentTitle from '../../hooks/useDocumentTitle';
import ShimmerLoader from '../../hooks/ShimmerLoader';
import formatDate from '../../hooks/formatDate';
import { getLoyaltyReportReward } from "../../services/api";
import Pagination from "../../hooks/Pagination";
import { useAuth } from "../../context/AuthContext";

import toastr from 'toastr';

import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/light.css";

import { format } from 'date-fns';

export default function RewardReports() {
  const { user } = useAuth();
  useDocumentTitle('Welcome to Admin | Loyalty Card');
  const [loyalty_card, setLoyaltyCard] = useState([]);
  const [loyalty_program, setLoyaltyProgram] = useState([]);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [cardNumber, setcardNumberGen] = useState('');

  const perPage = 100;
  const FetchLoyaltyReport = async (perPage, currentPage) => {
    try {
      const response = await getLoyaltyReportReward(perPage, currentPage);
      const data = await response.data;
      setLoyaltyCard(data.data || data); // Adjust based on your API response structure
      setCurrentPage(data.current_page);
      setTotalPages(data.last_page);
    } catch (err) {
      setError(err.message || 'Failed to fetch Loyalty Card');
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    FetchLoyaltyReport(perPage, currentPage);
  }, [currentPage]);
  
  const initialFormData = {
    card_id: 0,
    program_id: "",
    status: "active",
    card_number: '',
    card_type: "",
    issue_date: new Date(),
    initial_points: "0",
    expiration_date: new Date(),
  };
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    card_id: 0,
    program_id: "",
    status: "active",
    card_number: cardNumber,
    card_type: "",
    issue_date: new Date(),
    initial_points: "0",
    expiration_date: new Date(),
  });
  const handleOpen = () => {
    setFormData(initialFormData)
    setOpen(!open)
    
  };

  const handleChange = (e, field = '') => {
    let name = '';
    let value = '';
    if (e.target) {
      name = e.target.name;
      value = e.target.value;
    } else {
      name = field//field.name;
      value = e;
    }
    console.log(e);

    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
  };

  return (
    <>

      <div className="flex flex-col md:flex-row gap-4 md:gap-4">

        {error && <div style={{ color: 'red' }}>{error}</div>}

        {open && (

          <>
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">

              <form onSubmit={handleSubmit}>
                <div className="bg-white rounded-lg shadow-xl min-w-[300px] w-[60vw] max-w-[900px] max-h-[95vh] flex flex-col">
                  <div className="flex justify-between items-center border-b px-6 py-4">
                    <h3 className="text-lg font-semibold">{(formData.card_id > 0) ? 'Edit' : 'Add'} Card</h3>
                    <button
                      type="button"
                      onClick={() => setOpen(false)}
                      className="text-gray-500 hover:text-gray-700"
                    >
                      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  </div>
                  <div className="p-4 space-y-4 overflow-y-auto flex-grow">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      
                      <div>
                        <label className="block text-sm font-medium mb-1">Card Number </label>
                        <div className="relative">
                          <input
                            type="text"
                            name="card_number"
                            value={formData.card_number || cardNumber}
                            onChange={handleChange}
                            placeholder="OZS-9876565656"
                            className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                          />
                          <IdCard className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                        </div>
                      </div>

                      <div>
                        <label className="block text-sm font-medium mb-1">Card Type</label>
                        <div className="relative">
                          <select name="card_type" value={formData.card_type || ""} onChange={handleChange} className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                          >
                            <option value="" disabled>Select</option>
                            <option value="standard">Standard</option>
                            <option value="premium">Premium</option>
                            <option value="family">Family</option>
                            <option value="corporate">corporate</option>
                          </select>
                          <ListCheck className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                        </div>
                      </div>
                      <div>
                        <label className="block text-sm font-medium mb-1">Initial Points</label>
                        <div className="relative">
                          <input
                            type="text"
                            name="initial_points"
                            value={formData.initial_points || ""}
                            onChange={handleChange}
                            placeholder="0"
                            className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                          />
                          <Gift className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                        </div>
                      </div>

                      <div>
                        <label className="block text-sm font-medium mb-1">Issue Date</label>
                        <div className="relative">
                          <Flatpickr
                            value={formData.issue_date}
                            // onChange={([date]) => handleChange(date, 'issue_date')}
                            onChange={([date]) => {
                              handleChange(date, 'issue_date')

                              if (formData.issue_date && formData.expiration_date && formData.expiration_date < formData.issue_date) {
                                handleChange(date, 'expiration_date')
                              }
                            }}
                            options={{
                              minDate: 'today',
                              enableTime: true,
                              time_24hr: true,
                              defaultDate: null,
                              altFormat: 'Y-m-d H:i (UTCZ)',
                              dateFormat: "d/m/Y H:i", // Format: DD/MM/YYYY
                            }}
                            placeholder="Select a date"
                            className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                          />
                          <CalendarDays className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                        </div>
                      </div>
                      <div>
                        <label className="block text-sm font-medium mb-1">Expiry Date</label>
                        <div className="relative">
                          <Flatpickr
                            value={formData.expiration_date}
                            onChange={([date]) => handleChange(date, 'expiration_date')}
                            options={{
                              enableTime: true,
                              time_24hr: true,
                              defaultDate: null,
                              altFormat: 'Y-m-d H:i (UTCZ)',
                              dateFormat: "d/m/Y H:i", // Format: DD/MM/YYYY
                              // minDate: format(formData.issue_date, 'yyyy-mm-dd'),
                            }}
                            placeholder="Select a date"
                            className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                          />

                          <CalendarDays className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                        </div>
                      </div>

                      <div>
                        <label className="block text-sm font-medium mb-1">Status</label>
                        <div className="relative">
                          <select name="status" value={formData.status || ""} onChange={handleChange} className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                          >
                            <option value="" disabled>Select</option>
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                            <option value="lost">Lost</option>
                            <option value="stolen">Stolen</option>
                            <option value="expired">Expired</option>
                          </select>
                          <ListCheck className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                        </div>
                      </div>
                    </div>

                  </div>

                  <div className="flex justify-end border-t px-6 py-4">
                    <button
                      type="submit"
                      className="w-full bg-[#f4a406] text-white py-2 rounded-xl hover:bg-[#d89005] transition-colors"
                    >
                      Save
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </>
        )}

        <div className="w-full  bg-white shadow-lg rounded-2xl p-6">

          <div className="grid grid-flow-col grid-rows-3 gap-4">
            <div className="row-start-1 row-end-4"><h2 className="text-2xl font-bold mb-4">Rewards Wise Report</h2></div>
            
            <div className="row-start-1 row-end-4 text-right">
              <button type="button" className="py-2 px-4  bg-[#f4a406] text-white py-2 rounded-xl hover:bg-[#d89005] transition-colors">Filter</button>
            </div>
          </div>
          <div className="overflow-auto">

            <table className="w-full text-sm text-left">
              <thead className="text-gray-700 bg-gray-100">
                <tr>
                  <th className="p-3">Reward Name </th>
                  <th className="p-3">Description</th>
                  <th className="p-3">Total Order</th>
                  <th className="p-3">Total Discount </th>
                </tr>
              </thead>
              <tbody className="divide-y">
                {loading ? (
                  <>
                    <tr>
                      <td className="p-3" colSpan={4}>
                        <ShimmerLoader />
                        <ShimmerLoader />
                        <ShimmerLoader />
                      </td>
                    </tr>
                  </>
                ) : (
                  <>
                    {!loading && loyalty_card.length > 0 ? (
                      loyalty_card.map((item) => (
                        <tr key={item.reward_id}>
                          <td className="p-3">{item.reward_name}</td>
                          <td className="p-3">{item.description}</td>
                          <td className="p-3">{item.total_order_amount}</td>
                          <td className="p-3">{item.total_discount}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td className="p-3" colSpan={7}>
                          No record found
                        </td>
                      </tr>
                    )}

                  </>
                )}

              </tbody>
            </table>
            <Pagination totalPages={totalPages} currentPage={currentPage} setCurrentPage={setCurrentPage} />
          </div>
        </div>
      </div>

    </>
  );
}
